<style lang="less" scope>
  .pop-calendar-wrap-sku{
    position: relative;
    overflow: hidden;
    border-right: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    border-top: 1px solid #e8e8e8;
    box-sizing: border-box;
  /*
  * Container style
  */
  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
    position: relative;
  }

  /*
  * Scrollbar rail styles
  */
  .ps__rail-x {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    height: 15px;
    /* there must be 'bottom' or 'top' for ps__rail-x */
    bottom: 0px;
    /* please don't change 'position' */
    position: absolute;
    z-index: 3;
  }

  .ps__rail-y {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    width: 15px;
    /* there must be 'right' or 'left' for ps__rail-y */
    right: 0;
    /* please don't change 'position' */
    position: absolute;
    z-index: 3;
  }

  .ps--active-x > .ps__rail-x,
  .ps--active-y > .ps__rail-y {
    display: block;
    background-color: transparent;
  }

  .ps:hover > .ps__rail-x,
  .ps:hover > .ps__rail-y,
  .ps--focus > .ps__rail-x,
  .ps--focus > .ps__rail-y,
  .ps--scrolling-x > .ps__rail-x,
  .ps--scrolling-y > .ps__rail-y {
    opacity: 0.6;
  }

  .ps .ps__rail-x:hover,
  .ps .ps__rail-y:hover,
  .ps .ps__rail-x:focus,
  .ps .ps__rail-y:focus,
  .ps .ps__rail-x.ps--clicking,
  .ps .ps__rail-y.ps--clicking {
    background-color: #eee;
    opacity: 0.9;
  }

  /*
  * Scrollbar thumb styles
  */
  .ps__thumb-x {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, height 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
    height: 6px;
    /* there must be 'bottom' for ps__thumb-x */
    bottom: 2px;
    /* please don't change 'position' */
    position: absolute;
  }

  .ps__thumb-y {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, width 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
    width: 6px;
    /* there must be 'right' for ps__thumb-y */
    right: 2px;
    /* please don't change 'position' */
    position: absolute;
  }

  .ps__rail-x:hover > .ps__thumb-x,
  .ps__rail-x:focus > .ps__thumb-x,
  .ps__rail-x.ps--clicking .ps__thumb-x {
    background-color: #999;
    height: 11px;
  }

  .ps__rail-y:hover > .ps__thumb-y,
  .ps__rail-y:focus > .ps__thumb-y,
  .ps__rail-y.ps--clicking .ps__thumb-y {
    background-color: #999;
    width: 11px;
  }

  /* MS supports */
  @supports (-ms-overflow-style: none) {
    .ps {
      overflow: auto !important;
    }
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .ps {
      overflow: auto !important;
    }
  }

  .calendar {
    border-collapse: collapse;
    

    & td,
    & th {
      color: #333;
      border: 1px solid #e8e8e8;
      height: 48px;
      line-height: 1;
      cursor:pointer;
    }
    & th {
      padding: 0 5px;
      vertical-align: middle!important;
      font-style: normal;
      font-weight: normal;
      background-color: #fafafa;
      line-height: 1;
      border-top: none;
    }
    .today{
      background-color: #f3fcff!important;
    }
    & th.column {
      padding: 0 5px;
    }
    & tbody td.col {
      background-color: #f8f8fa!important;
      padding: 0 5px;
      vertical-align: middle;
      white-space: normal;
    }

    & tbody td {
      background-color: #fff!important;
      height: 80px;
      padding: 0;
      vertical-align: top;
      // padding-top: 10px;
      box-sizing: border-box;
      text-align: center;
    }
  }
  .top-fixed {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .left-fixed {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .left-top-fixed {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
  }
  .hidden {
    visibility: hidden;
  }
  .progress:nth-child(odd){
    height: 14px;
    width: 100%;
    position: relative;
    cursor: pointer;
    background-color: #fb81a4;
  }
  .progress:nth-child(even){
    height: 14px;
    width: 100%;
    position: relative;
    cursor: pointer;
    background-color: #00c6dc;
  }
  

  .progress .text{
    font-size: 12px;
    position: absolute;
    left:10px; 
    color: #fff;
    line-height: 14px;
  }
  .progress.start {
    border-top-left-radius: 12.5px;
    border-bottom-left-radius: 12.5px;
  }
  .progress.end {
    border-top-right-radius: 12.5px;
    border-bottom-right-radius: 12.5px;
  }

}
</style>

<template>
  <div class="pop-calendar-wrap-sku" id="pop-calendar-wrap-sku" ref="calendarWrap" :style="style">
    <div class="left-top-fixed">
      <table
        class="calendar"
        cellpadding="0"
        cellspacing="0"
        style="border-collapse:collapse"
        :style="'width: '+((75*colspan))+'px;'"
      >
        <colgroup>
          <col width="75" v-for="it in colspan">
        </colgroup>
        <thead>
          <tr >
            <th :colspan="1" v-for="(index,it) in leftHeader" :key="$index">{{leftHeader[index]}}</th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="top-fixed" :style="'width:'+((75*colspan)+(138*timeLine.length))+'px'">
      <table
        class="calendar"
        cellpadding="0"
        cellspacing="0"
        style="border-collapse:collapse"
        :style="'width: '+((75*colspan)+(138*timeLine.length))+'px;'"
      >
        <colgroup>
          <col width="75" v-for="it in colspan" >
          <col width="138" v-for="it in timeLine" >
        </colgroup>
        <thead>
          <tr>
            <th v-for="it in colspan" class="hidden" :width="75" ></th>
            <th v-for="it in timeLine" class="column" :class="{today:isToday(it)}" :key="$index" >{{it.timeStrDesc}}</th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="left-fixed" id="left-fixed"  :data-scroll="scrollTop" :style="'width:'+(75*colspan)+'px'">
      <table
        class="calendar"
        cellpadding="0"
        cellspacing="0"
        style="border-collapse:collapse"
        :style="'width: '+((75*colspan)+(138*timeLine.length))+'px;'"
      >
       <colgroup>
          <col width="75" v-for="it in colspan" >
          <col width="138" v-for="it in timeLine" >
        </colgroup>
        <thead>
          <tr>
            <th :colspan="colspan" class="hidden">{{leftHeader}}</th>
            <th v-for="it in timeLine" class="column hidden" ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(indexs,its) in leftData" :key="$index">
            <td class="col" v-for="(index,it) in its.cols" :rowspan="it.rowspan" :key="$index">{{it.name}}</td>
            <!--<td v-for="it in timeLine" class="hidden"  :key="$index">
              <div
                class="progress"
                :class="getProgressClass(it,row)"
                v-for="row in its.data"
                :style="getColor(it,row)"
                @click="itemClick(row,it)"
                @mouseover="itemHover(row,it)"
                :key="$index"
              >
                <div class="text">
                  {{it.startTime==row.startTime?row.name:''}}
                </div>
              </div>
            </td>-->
          </tr>
        </tbody>
      </table>
    </div>
    <div class="wrap" :style="style" v-el:content id="content">
    <!--v-selectable-->
      <table
        class="calendar"
        cellpadding="0"
        cellspacing="0"
        style="border-collapse:collapse"
        :style="'width: '+((75*colspan)+(138*timeLine.length))+'px;'"
      >
         <colgroup>
          <col width="75" v-for="it in colspan">
          <col width="138" v-for="it in timeLine">
        </colgroup>
        <thead>
          <tr>
            <th :colspan="colspan" class="hidden">{{leftHeader}}</th>
            <th v-for="it in timeLine" class="column hidden" ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(indexs,its) in leftData" :key="$index">
            <td class="hidden" v-for="(index,it) in its.cols" :rowspan="it.rowspan" :key="$index">{{it.name}}</td>
            <td  v-for="it in timeLine"  :class="{today:isToday(it)}" :key="$index" @click="toClick($event)">
             <div :data-id="row.classificationId" :data-name="row.actName" :data-time="it.startTime"
                class="progress"
                :class="getProgressClass(it,row)"
                v-for="row in its.data"
                :style="getColor(it,row)"
               @click="itemClick(row,it)"
               :key="$index"
              >
                <div class="text">
                  {{new Date(it.startTime).convert("yyyyMMdd")==new Date(it.endTime).convert("yyyyMMdd")?new Date(it.startTime).convert("yyyyMMdd")==new Date(row.startTime).convert("yyyyMMdd")?row.name:'':new Date(it.startTime).convert("yyyyMM")==new Date(row.startTime).convert("yyyyMM")?row.name:''}}
                </div>
              </div> 
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
Date.prototype.convert = function(format) {
    var args = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
        "S": this.getMilliseconds()
    };
    if(/(y+)/.test(format))
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for(var i in args) {
        var n = args[i];
        if(new RegExp("(" + i + ")").test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? n : ("00" + n).substr(("" + n).length));
    }
    return format;
};
import { PRE } from "../../common/utils/assist";
import PerfectScrollbar from "perfect-scrollbar";
const prefixCls = `${PRE}-table`;
let $ = document.querySelector.bind(document);
export default {
  props: {
    style: {
      type: String,
      default: ""
    },
    timeLine: {
      type: Array,
      default() {
        return [];
      }
    },
    colors: {
      type: Array,
      default() {
        return [
          "#fb81a4",
          "#ffdc04",
          "#5ed562",
          "#3fd5ff",
          "#f64cc9",
          "#9771cf"
        ];
      }
    },
    leftData: {
      type: Array,
      default() {
        return [];
      }
    },
    leftHeader: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  
  data() {
    return {
      // leftHeader: "活动分类",
      // leftDataClone:[]
      scrollTop:"",
      divList:[]
    };
  },
  computed: {
    colspan() {
      if (
        this.leftData.length &&
        this.leftData[0].cols &&
        this.leftData[0].cols.length
      ) {
        return this.leftData[0].cols.length;
      }
      return 0;
    },
    wrapClasses() {
      return [
        `${prefixCls}-wrapper`,
        {
          [`${prefixCls}-hide`]: !this.ready,
          [`${prefixCls}-with-header`]: this.showSlotHeader,
          [`${prefixCls}-with-footer`]: this.showSlotFooter
        }
      ];
    }
  },
  ready() {
    let content = $("#content");
    const ps = new PerfectScrollbar(content, {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20
    });
    
    content.addEventListener("scroll", () => {
      this.scrollTop = ps.lastScrollTop;
      $(".top-fixed").style.setProperty(
        "left",
        -ps.lastScrollLeft + "px",
        "important"
      );
      $(".left-fixed").style.setProperty(
        "top",
        -ps.lastScrollTop + "px",
        "important"
      );

    });
  },
  methods: {
    toClick (event) {
      let objArray = event.srcElement.children
      let obj = null
      for(let i=0;i<objArray.length;i++){
        if(objArray[i].classList.length>1){
          obj = objArray[i]
        }
      }
      obj = obj?obj:objArray[0]
      obj? obj.click():null
    },
    getColor(it, row){
      // :style="'background-color:'+row.color"
      let isSameDay=new Date(it.startTime).convert("yyyyMMdd")==new Date(it.endTime).convert("yyyyMMdd");
      let color="";
      let isNone = ''
      if(isSameDay){
        new Date(it.startTime).convert("yyyyMMdd")*1>=new Date(row.startTime).convert("yyyyMMdd")*1&&new Date(it.endTime).convert("yyyyMMdd")*1<=new Date(row.endTime).convert("yyyyMMdd")*1?color=row.color:color='';
         isNone = color!=''?'block':'none'
      }else{
        new Date(it.startTime).convert("yyyyMM")>=new Date(row.startTime).convert("yyyyMM")&&new Date(it.endTime).convert("yyyyMM")*1<=new Date(row.endTime).convert("yyyyMM")*1?color=row.color:color='';
         isNone = color!=''?'block':'none'
      }
      
      // console.log(isNone)
      return `background-color:${color};display:${isNone}`;
    },
    getProgressClass(it, row) {
      // console.log(new Date(it.startTime).convert("yyyy-MM-dd"),new Date(row.startTime).convert("yyyy-MM-dd"));
      let isSameDay=new Date(it.startTime).convert("yyyyMMdd")==new Date(it.endTime).convert("yyyyMMdd");
      return {
        start:new Date(it.startTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM") == new Date(row.startTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM"),
        center:new Date(it.startTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM") > new Date(row.startTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM") && new Date(it.endTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM") < new Date(row.endTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM"),
        end: new Date(it.endTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM") == new Date(row.endTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM")
      };
    },
    isToday(it){
      let isSameDay=new Date(it.startTime).convert("yyyyMMdd")==new Date(it.endTime).convert("yyyyMMdd");
      return new Date(it.startTime).convert(isSameDay?"yyyy-MM-dd":"yyyy-MM")==new Date().convert(isSameDay?"yyyy-MM-dd":"yyyy-MM");
    },
    itemClick(row,it){
      this.$emit("on-click",row,it);
    },
    itemHover(row,it){
      this.$emit("on-hover",row,it);
    }
  }
};
</script>



// WEBPACK FOOTER //
// calendar-sku.vue?78a87e46